module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./RegisterBrowseView.js"));
	}, "RegisterBrowseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=RegisterBrowseView!./src/pages/Store/BusinessManage/RegisterBrowse/RegisterBrowseView.js
// module id = 1189
// module chunks = 438